enum RenderingEngineModeEnum {
  Standard = 'standard',
  Next = 'next',
}

export default RenderingEngineModeEnum;
